var React = require('react');

function Vector (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.8462 16.8298L19.9533 10.7226L21.5851 12.3544L13.8462 20.0934L8.41488 14.6621L10.0467 13.0303L13.8462 16.8298Z","fill":"#00BAC7","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 2.30769C7.99023 2.30769 2.30769 7.99023 2.30769 15C2.30769 22.0098 7.99023 27.6923 15 27.6923C22.0098 27.6923 27.6923 22.0098 27.6923 15C27.6923 7.99023 22.0098 2.30769 15 2.30769ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z","fill":"#00BAC7","key":1})]);
}

Vector.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Vector;

Vector.default = Vector;
